import { SWRResponse } from 'swr'
import useSWRImmutable from 'swr/immutable'
import { getFulfilmentOptions } from '../api/fulfilment-options'
import { FulfilmentOption } from '../types'

export type FulfilmentOptionsResponse = Pick<
  SWRResponse<FulfilmentOption[], Error>,
  'data' | 'error' | 'isLoading'
>

export const useFulfilmentOptions = (
  vehicleId?: string,
): FulfilmentOptionsResponse => {
  const { data, error, isLoading } = useSWRImmutable<
    FulfilmentOption[] | undefined,
    Error
  >(vehicleId ?? null, getFulfilmentOptions, {
    errorRetryCount: 1,
  })

  return { data, error, isLoading }
}
